(function(){
  var scope = document.querySelector('.ova-apple');
  if (!scope) return;

  /* Police Lora pour le corps de texte */
  var font = document.createElement('link');
  font.rel = 'stylesheet';
  font.href = 'https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,500;0,600;1,400&display=swap';
  document.head.appendChild(font);

  /* Le <style> de la section est injecte apres la feuille externe et gagne
     la priorite. On applique donc ces regles ici, en dernier. */
  var fix = document.createElement('style');
  fix.id = 'ova-fix-inline';
  fix.textContent = [
    /* --- POLICE : Lora en corps, Marcellus conservee en titres --- */
    ".ova-apple{font-family:'Lora',Georgia,serif!important;font-size:16.5px!important}",
    ".ova-apple .ova-eyebrow{font-family:'Lora',Georgia,serif!important;letter-spacing:.16em!important}",
    ".ova-apple .ova-btn{font-family:'Lora',Georgia,serif!important;font-weight:500!important}",
    ".ova-apple .ova-pack-title,.ova-apple .ova-pack-total{font-family:'Lora',Georgia,serif!important}",
    /* --- IMAGE : width/height du HTML entraient en conflit avec aspect-ratio --- */
    '.ova-apple .ova-incl-media img{width:100%!important;height:auto!important;aspect-ratio:4/3!important;object-fit:cover!important;object-position:center 58%!important;display:block!important}',
    '.ova-apple .ova-hero-figure img{width:100%!important;height:auto!important;display:block!important}',
    '@media (max-width:860px){.ova-apple .ova-incl-media img{aspect-ratio:16/9!important}}',
    /* --- CENTRAGE --- */
    '.ova-apple .ova-benefit{align-items:center!important;text-align:center!important}',
    '.ova-apple .ova-benefit .ova-icon{margin-left:auto!important;margin-right:auto!important}',
    '.ova-apple .ova-step{align-items:center!important;text-align:center!important}',
    /* --- SURVOL --- */
    '.ova-apple .ova-benefit,.ova-apple .ova-step{transition:transform .3s cubic-bezier(.16,.8,.24,1),box-shadow .3s,border-color .3s}',
    '.ova-apple .ova-icon{transition:transform .3s cubic-bezier(.16,.8,.24,1)}',
    '.ova-apple .ova-pack{transition:transform .25s cubic-bezier(.16,.8,.24,1),box-shadow .25s,border-color .2s,background .2s}',
    '.ova-apple .ova-faq-item{transition:border-color .25s,background .25s}',
    '.ova-apple .ova-inci-row{transition:background .2s}',
    '.ova-apple .ova-plus::after,.ova-apple .ova-plus::before{transition:transform .3s cubic-bezier(.16,.8,.24,1),background .25s}',
    '@media (hover:hover){',
    '.ova-apple .ova-benefit:hover,.ova-apple .ova-step:hover{transform:translateY(-4px);box-shadow:0 18px 40px -20px rgba(0,0,0,.55)}',
    '.ova-apple .ova-benefit:hover .ova-icon{transform:scale(1.12)}',
    '.ova-apple .ova-pack:hover{transform:translateY(-2px);box-shadow:0 12px 28px -16px rgba(21,42,28,.45);border-color:var(--ova-forest-soft)}',
    '.ova-apple .ova-faq-item:hover{border-color:var(--ova-gold-soft);background:color-mix(in srgb,var(--ova-forest-soft) 80%,var(--ova-gold) 6%)}',
    '.ova-apple .ova-faq-item:hover .ova-plus::before,.ova-apple .ova-faq-item:hover .ova-plus::after{background:var(--ova-gold)}',
    '.ova-apple .ova-faq-item:hover .ova-plus::after{transform:rotate(90deg)}',
    '.ova-apple .ova-faq-item[open]:hover .ova-plus::after{transform:rotate(90deg)}',
    '.ova-apple .ova-inci-row:not(.ova-inci-head):hover{background:var(--ova-isle)}',
    '.ova-apple .ova-nav-links a:hover{color:var(--ova-gold-soft)}',
    '}',
    /* --- PIED DE PAGE : harmonise avec la maquette --- */
    ".footer-content{text-align:center}",
    ".footer-content .text-block--align-left{--text-align:center!important;text-align:center!important}",
    ".footer-content .layout-panel-flex--column{--horizontal-alignment:center!important;align-items:center!important}",
    ".footer-content h3{font-family:Marcellus,Georgia,serif!important;font-weight:400!important;font-size:22px!important}",
    ".footer-content input[type=email],.footer-content input[type=text]{border-radius:999px!important;padding:14px 20px!important}",
    ".footer-content button,.footer-content .button{border-radius:999px!important;padding:14px 28px!important}",
    ".footer-content{padding-block-start:72px!important}"
  ].join('');
  document.head.appendChild(fix);

  var nav = scope.querySelector('#ovaNav');
  var onScroll = function(){ if (nav) nav.classList.toggle('ova-scrolled', window.scrollY > 8); };
  document.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var packs = scope.querySelectorAll('.ova-pack');
  var variantInput = scope.querySelector('#ovaSelectedVariant');
  var btnPrice = scope.querySelector('#ovaBtnPrice');
  var stickyPrice = scope.querySelector('#ovaStickyPrice');

  function select(btn){
    packs.forEach(function(p){ p.setAttribute('aria-pressed','false'); });
    btn.setAttribute('aria-pressed','true');
    if (variantInput) variantInput.value = btn.getAttribute('data-variant');
    var price = btn.getAttribute('data-price');
    if (btnPrice) btnPrice.textContent = price;
    if (stickyPrice) stickyPrice.textContent = price;
  }
  packs.forEach(function(btn){ btn.addEventListener('click', function(){ select(btn); }); });
  if (packs.length) select(packs[0]);

  var buyForm = scope.querySelector('#ovaBuyForm');
  var buyError = scope.querySelector('#ovaBuyError');
  if (buyForm) {
    buyForm.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = buyForm.querySelector('button[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (buyError) { buyError.hidden = true; buyError.textContent = ''; }
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout en cours...'; }
      fetch('/cart/add.js', { method:'POST', body:new FormData(buyForm), headers:{'Accept':'application/json'} })
        .then(function(r){ if (!r.ok) { return r.json().then(function(err){ throw err; }); } return r.json(); })
        .then(function(){ window.location.href = '/cart'; })
        .catch(function(){
          if (btn) { btn.disabled = false; btn.innerHTML = original || 'Ajouter au panier'; }
          if (buyError) { buyError.hidden = false; buyError.textContent = "Une erreur est survenue, merci de réessayer."; }
        });
    });
  }
})();
